import { PopUpAlert } from 'components/pop-up-alert';
import { FormattedMessage } from 'react-intl';
import { OpenInWorkspaces } from 'routes/smart-quote/components/prompt-results/components/quick-actions/open-in';
import { usePopUpAlert } from 'routes/smart-quote/components/prompt-results/components/quick-actions/useCopyToClipboardWithPopUp';
import { SmartQuoteParsingResult } from 'state/workspaces/smart-quote/model';

import { ShareFeedback } from './share-feedback';

type QuickActionsProps = {
  results: SmartQuoteParsingResult[];
  copyToClipboard: () => Promise<void>;
};

export function QuickActions({ results, copyToClipboard }: QuickActionsProps) {
  const { popUp, showSuccess, showError, close } = usePopUpAlert();
  const hasError = results.some(result => result.status === 'Error');
  const handleCopyToClipboard = async () => {
    try {
      await copyToClipboard();
      showSuccess();
    } catch {
      showError();
    }
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-2 flex-grow-1">
          <button className="btn btn-flat-secondary btn-icon-start" onClick={handleCopyToClipboard}>
            <i className="icon icon-outlined" aria-hidden="true">
              content_copy
            </i>
            <FormattedMessage id="smartQuote.quickActions.copyToClipboard" />
          </button>
          {!hasError && <OpenInWorkspaces results={results} />}
        </div>
        <ShareFeedback results={results} />
      </div>

      <PopUpAlert
        show={popUp.show}
        className="mx-auto flex-x gap-2 py-1"
        color={popUp.isError ? 'error' : 'secondary'}
        onClose={close}
        duration={2_000}
      >
        <span aria-hidden="true" className="icon">
          content_copy
        </span>
        <FormattedMessage
          id={
            popUp.isError
              ? 'smartQuote.quickActions.copyToClipboard.quotes.error'
              : 'smartQuote.quickActions.copyToClipboard.quotes.success'
          }
        />
      </PopUpAlert>
    </>
  );
}
